// Copyright (c) 2016 Deere & Company

import './app-container.scss';
import React, {PropTypes} from 'react';
import {
    createErrorObject,
    errorAlertBar
} from '../shared/services/alert-bar';
import {
    getFaviconUrl,
    getThemeClass
} from '../user/shared/services/themes';
import {
    getSearchBy,
    getSearchBySelectedOption,
    mapClaimValidation,
    mapSearchPlaceHolder,
    mapValidationErrorMessages
} from '../home-page/shared/services/home-page-helper';
import {AlertBarContainer} from '../shared/components/alert-bar-container';
import AlertMessages from '../shared/state/alert-messages';
import AppConfig from '../shared/models/app-config';
import AppDynamics from './appdynamics';
import AppLogo from './app-logo';
import Breadcrumbs from './breadcrumbs';
import DataDog from './datadog';
import DocumentTitle from 'react-document-title';
import Favicon from './favicon';
import {FormattedMessage} from 'react-intl';
import Greeting from './greeting';
import IEPasteFix from './ie-paste-fix';
import InlineAlertBar from '../shared/components/inline-alert-bar';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import Link from '@deere/cps-it.warranty-model-factory/lib/link';
import MainMenu from './main-menu';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import SessionExpiredModal from '../shared/components/session-expired-modal/';
import TranslatedInput from '../shared/components/translated-input';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WalkMe from './walkme';
import {stripSpaces} from '../shared/services/strip-spaces';
import {translate} from '../shared/services/translation-service';

const dismissActionMap = {
    error: 'dismissErrorMessages',
    info: 'dismissInfoMessages',
    success: 'dismissSuccessMessages',
    warning: 'dismissWarningMessages'
};

const getDismissHandler = actions =>

    messageType => {

        const dismissMethod = actions[dismissActionMap[messageType]];

        if (dismissMethod) {

            dismissMethod();

        }

    };

class AppContainer extends React.Component {

    state = {
        searchBy: getSearchBy(this.props.security),
        searchQuery: '',
        selectedDropDownOption: getSearchBySelectedOption(getSearchBy(this.props.security))
    };

    getChildContext() {

        return {
            constants: this.props.constants,
            security: this.props.security,
            user: this.props.user
        };

    }

    componentWillMount() {

        this.props.actions.readFavorites(this.props.user.id);
        this.props.actions.readLinks();
        this.props.actions.readClaimTypes();
        this.props.actions.readSubClaimTypes();

    }

    handleSapEnvironmentChange = newEnvironment => {

        const newEnvironments = this.props.appConfig.sapEnvironments.map(env => {

            if (env.name === newEnvironment) {

                return ({
                    ...env,
                    defaultVal: true
                });

            }

            return ({
                ...env,
                defaultVal: false
            });

        });

        this.props.actions.updateSelectedSapEnvironment(newEnvironments);

    };

    getDocumentTitle = () => {

        let routeName;

        const applicationNameToDisplay = translate('WARRANTY');

        if (this.props.routes.length) {

            routeName = this.props.routes[this.props.routes.length - 1].name;

        }

        return routeName ?
            `${translate(routeName)} - ${applicationNameToDisplay}` :
            applicationNameToDisplay;

    };

    toggleSearch = () => {

        const expandableSearch = document.querySelector('.expandable-search');

        if (expandableSearch.classList.contains('searchActive')) {

            expandableSearch.classList.remove('searchActive');
            document.removeEventListener('mousedown', this.handleOffSearchClick, false);

        } else {

            expandableSearch.classList.add('searchActive');
            document.addEventListener('mousedown', this.handleOffSearchClick, false);
            document.querySelector('.expandable-search input').focus();

        }

    };

    handleOffSearchClick = e => {

        if (!this.searchNode.contains(e.target) && this.searchNode.classList.contains('searchActive')) {

            this.toggleSearch();

        }

    };

    handleInputChange = event => {

        this.setState({
            searchQuery: event.target.value
        });

    };

    performHeaderSearch = () => {

        const {searchQuery, selectedDropDownOption} = this.state;

        const trimmedSearchQuery = stripSpaces(searchQuery);

        if (trimmedSearchQuery) {

            if (mapClaimValidation(selectedDropDownOption, trimmedSearchQuery)) {

                this.props.actions.onHeaderSearch(selectedDropDownOption, trimmedSearchQuery);

                this.setState({
                    searchQuery: '',
                    selectedDropDownOption: this.state.searchBy[0].key

                });

                this.toggleSearch();

            } else {

                const translatedErrorMessage = translate(mapValidationErrorMessages(selectedDropDownOption));

                errorAlertBar(createErrorObject(translatedErrorMessage));
                document.querySelector('.expandable-search input').focus();

            }

        } else {

            this.toggleSearch();

        }

    };

    handleSearch = event => {

        event.preventDefault();

        const expandableSearch = document.querySelector('.searchActive');

        expandableSearch ? this.performHeaderSearch() : this.toggleSearch();

    };

    handleFocus = event => {

        if (event.target.value) {

            event.target.select();

        }

    };

    handleOptionChange = event => {

        this.setState({selectedDropDownOption: event.target.value});

    };

    render() {

        const faviconUrl = getFaviconUrl(this.props.user.settings.theme.preferredTheme.key);
        const themeClass = getThemeClass(this.props.user.settings.theme.preferredTheme.key);

        return (

            <section className={`app-container ${themeClass}`}>
                <Favicon url={faviconUrl}/>
                <IEPasteFix/>
                <DocumentTitle title={this.getDocumentTitle()}/>
                <AppDynamics appConfig={this.props.appConfig}/>
                <DataDog appConfig={this.props.appConfig}/>
                <WalkMe
                    appConfig={this.props.appConfig}
                    isSapUp={this.props.isSapUp}
                    user={this.props.user}
                />
                <section className='app-header'>
                    <div className='expandable-search-row'>
                        <AppLogo/>
                        <section className='app-title'>
                            <h1>
                                <a href='/'><FormattedMessage id='WARRANTY'/></a>
                            </h1>
                            <Greeting
                                appConfig={this.props.appConfig}
                                firstName={this.props.user.firstName}
                                isSapUp={this.props.isSapUp}
                                lastName={this.props.user.lastName}
                                links={this.props.links}
                            />
                        </section>
                        {this.state.searchBy.length > 0 &&
                            <div
                                className='expandable-search'
                                ref={node => (this.searchNode = node)}
                            >
                                <form
                                    onSubmit={this.handleSearch}
                                    spellCheck={false}
                                >

                                    <select
                                        onChange={this.handleOptionChange}
                                        value={this.state.selectedDropDownOption}
                                    >
                                        {this.state.searchBy.map(option =>
                                            <option
                                                key={option.key}
                                                value={option.key}
                                            >
                                                {translate(option.value)}
                                            </option>)}
                                    </select>
                                    <TranslatedInput
                                        onChange={this.handleInputChange}
                                        onFocus={this.handleFocus}
                                        placeholder={mapSearchPlaceHolder(this.state.selectedDropDownOption)}
                                        type='text'
                                        value={this.state.searchQuery}
                                    />

                                </form>
                                <div
                                    className={this.state.searchQuery ? 'search-toggle btn' : 'search-toggle'}
                                    onClick={this.handleSearch}
                                >
                                    <svg
                                        className='search-toggle-icon'
                                        height='24'
                                        viewBox='0 0 24 24'
                                        width='24'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'
                                        />
                                        <path
                                            d='M0 0h24v24H0z'
                                            fill='none'
                                        />
                                    </svg>
                                </div>
                            </div>
                        }
                    </div>
                    <MainMenu
                        appConfig={this.props.appConfig}
                        isSapUp={this.props.isSapUp}
                        onSapEnvironmentChange={this.handleSapEnvironmentChange}
                    />
                </section>
                <section className='app-body'>
                    <Breadcrumbs
                        location={this.props.location}
                        params={this.props.params}
                        routes={this.props.routes}
                    />
                    {this.props.security.modules.length === 0 &&
                        <InlineAlertBar
                            label='NO_AUTHORITY_TO_ACCESS'
                            type='error'
                        />
                    }
                    {!this.props.isSapUp &&
                        <InlineAlertBar
                            label='SAP_DOWN_WARNING'
                            type='warning'
                        />
                    }
                    {this.props.children}
                </section>
                <SessionExpiredModal
                    isOpen={this.props.sessionExpiredModalVisibility}
                />
                <AlertBarContainer
                    errorMessages={this.props.alertMessages.errorMessages}
                    infoMessages={this.props.alertMessages.infoMessages}
                    onDismiss={getDismissHandler(this.props.actions)}
                    successMessages={this.props.alertMessages.successMessages}
                    warningMessages={this.props.alertMessages.warningMessages}
                />
            </section>
        );

    }

}

AppContainer.displayName = 'AppContainer';
AppContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    alertMessages: PropTypes.instanceOf(AlertMessages),
    appConfig: PropTypes.instanceOf(AppConfig).isRequired,
    children: PropTypes.node,
    constants: PropTypes.shape({
        claimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
        subClaimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
    }).isRequired,
    isSapUp: PropTypes.bool.isRequired,
    links: PropTypes.arrayOf(PropTypes.instanceOf(Link)).isRequired,
    location: PropTypes.object,
    params: PropTypes.object,
    routes: PropTypes.array,
    security: PropTypes.instanceOf(Security).isRequired,
    sessionExpiredModalVisibility: PropTypes.bool.isRequired,
    user: PropTypes.instanceOf(User).isRequired
};
AppContainer.childContextTypes = {
    constants: PropTypes.shape({
        allClaimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
        claimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
        subClaimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
    }).isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default AppContainer;



// WEBPACK FOOTER //
// ./src/app/app-container.js